import React, { useState } from "react";
import { ReactComponent as ActiveToggle } from "../../images/ActiveToggle.svg";
import { ReactComponent as ToggleDisabled } from "../../images/ToggleDisabled.svg";
import { ReactComponent as InactiveToggle } from "../../images/InactiveToggle.svg";
import { GetUserPreference } from "../../models/NotificationsModel/NotificationModel";
import { AxiosError, AxiosResponse } from "axios";
import { toast } from "react-toastify";
import SpinnerModel from "../../commonfields/SpinnerModel";
import { catchError } from "../../utils/Utils";
import Service from "../../services";

interface NotificationSettingsProps {
  appNotifiaction: any;
}
interface NotificationSettingsState {
  appNotifiaction: any;
  loader: boolean;
  todostatus: string;
}

class NotificationSettings extends React.Component<
  NotificationSettingsProps,
  NotificationSettingsState
> {
  Service: Service;

  constructor(props: NotificationSettingsState) {
    super(props);

    this.state = {
      appNotifiaction: " ",
      loader: false,
      todostatus: "",
    };
    this.Service = new Service();
  }

  componentDidMount() {
    // this.getUserPreference();
  }
  // getUserPreference=()=>{
  // this.Service.getUserPreference()
  // .then((response: AxiosResponse) => {
  //   if (response.status === 200) {
  //     this.setState({
  //       appNotifiaction: response.data,
  //     });
  //   }
  //   else {
  //     toast.error(
  //       <>
  //         <div className="fileErrorMessage">Something went wrong..</div>
  //       </>
  //     );
  //   }
  // })
  // .catch((error: any) => {
  //   catchError(error, true);
  // });
  // }

  todoStatusmail = () => {
    this.setState({ todostatus: "todostatus" });
  };
  updateUserPreference = (mailPreference: GetUserPreference) => {
    this.setState({ loader: true });
    // this.Service
    //   .updateUserPreference(mailPreference)
    //   .then(() => {
    //     this.setState({loader: false});
    //   this.getUserPreference()

    //   })
    //   .catch((err: AxiosError) => catchError(err, true))
    //   .finally(() => this.setState({loader: false}));
  };

  appTaskToggle(field: string) {
    const payload = {
      ...this.state.appNotifiaction,
      [field]: !this.state.appNotifiaction?.[field],
    };
    this.updateUserPreference(payload);
  }

  render() {
    return (
      <>
        <div className="notificationHeading">Notification Settings</div>
        <div className="body">
          <p className="line"></p>
          <div className="title">
            New Message from In Focus
            <div className="textNote">
              <span className="note">
                A notification when a client on your In Focus list sends you a
                message
              </span>
              <span className="btns">
                <span className="inAppBtn">
                  In-App{" "}
                  {this.state.appNotifiaction?.messageInApp == true ? (
                    <ToggleDisabled />
                  ) : (
                    <ActiveToggle />
                  )}
                </span>
                <span className="emailBtn">
                  Email{" "}
                  {this.state.appNotifiaction.messageEmail == true ? (
                    <ActiveToggle
                      onClick={() => {
                        this.appTaskToggle("messageEmail");
                      }}
                    />
                  ) : (
                    <InactiveToggle
                      onClick={() => {
                        this.appTaskToggle("messageEmail");
                      }}
                    />
                  )}
                </span>
              </span>
            </div>
          </div>
        </div>
        <div className="body">
          <p className="line"></p>
          <div className="title">
            New To-Do Task
            <div className="textNote">
              <span className="note">
                A notification when there is a new task available in your To-Do
              </span>
              <span className="btns">
                <span className="inAppBtn">
                  In-App{" "}
                  {this.state.appNotifiaction.todoInApp == true ? (
                    <ToggleDisabled />
                  ) : (
                    <ActiveToggle />
                  )}
                </span>
                <span className="emailBtn">
                  Email{" "}
                  {this.state.appNotifiaction.todoEmail == true ? (
                    <ActiveToggle
                      onClick={() => {
                        this.appTaskToggle("todoEmail");
                      }}
                    />
                  ) : (
                    <InactiveToggle
                      onClick={() => {
                        this.appTaskToggle("todoEmail");
                      }}
                    />
                  )}
                </span>
              </span>
            </div>
          </div>
        </div>
        <div className="body">
          <p className="line"></p>
        </div>

        {this.state.loader && (
          <SpinnerModel
            value={""}
            color={"primary"}
            size={""}
            type={"border"}
          />
        )}
      </>
    );
  }
}
export default NotificationSettings;
